import { Component, HostListener, Inject } from '@angular/core'
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { KeyingSystemService } from '../../../services/keying.system.service'
import { Observable, startWith, map } from 'rxjs'

@Component({
  selector: 'app-change-log-confirm-dialog',
  templateUrl: './change-log-confirmation-dialog.component.html',
  styleUrls: ['./change-log-confirmation-dialog.component.scss'],
  standalone: false,
})
export class ChangeLogConfirmationDialogComponent {
  confirmForm: FormGroup

  cancel = 'Cancel'
  confirm = 'Delete'
  showMessage = true
  showCancel = true
  reasonRequired = false
  currentDate = new Date()
  filteredReasons!: Observable<string[]>

  focus = {
    reason: false,
  }

  reasons = ['Cylinder/pinning error', 'Key System Expansion', 'Customer/Sales Request']

  public errorMessages = {
    reason: [{ type: 'required', message: 'A reason for taking this action is required.' }],
    details: [{ type: 'required', message: 'Detail for taking this action is required.' }],
  }

  @HostListener('document:keyup.enter', ['$event']) onEnterHandler(event: KeyboardEvent) {
    this.confirmSelected()
  }

  constructor(
    public form: FormBuilder,
    private dialogRef: MatDialogRef<ChangeLogConfirmationDialogComponent>,
    private keyingSystemService: KeyingSystemService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    dialogRef.disableClose = true

    this.confirmForm = this.form.group({
      reason: new FormControl('', [Validators.required]),
      details: new FormControl('', [Validators.required]),
    })

    this.filteredReasons = this.confirmForm.controls.reason.valueChanges.pipe(
      startWith(''),
      map((value) => this._filterReasons(value || ''))
    )
  }

  /* istanbul ignore next */
  private _filterReasons(value: string): string[] {
    const filterValue = value.toLowerCase()
    return this.reasons.filter((reason) => reason.toLowerCase().includes(filterValue))
  }

  focusOn(focus) {
    this.focus[focus] = !this.focus[focus]
  }

  fieldHasErrorMessages(form, validation, fieldName) {
    const field = form.get(fieldName)

    return Boolean(field.hasError(validation.type) && (field.dirty || field.touched))
  }

  fieldHasError(form, fieldName) {
    const field = form.get(fieldName)

    return Boolean(field.invalid && (field.dirty || field.touched))
  }

  cancelSelected(): void {
    this.dialogRef.close({ confirmed: false, reason: null })
  }

  confirmSelected(): void {
    this.dialogRef.close({
      confirmed: true,
      auditTrailRequest: {
        reasonCode: this.confirmForm.controls.reason.value,
        description: this.confirmForm.controls.details.value,
      },
    })
  }
}
